import  React, { useEffect, useState } from 'react'
import { db } from './firebase'
import './Orders.css'
import Order from "./Order";


function Orders() {
    const [orders, setOrders] = useState([])
    const [{cart, user}, dispatch] = useState([])

// useEffect(() =>{
//     if(user){    
//     db.collection('users')
//     .doc(user?.uid)
//     .collection('orders')
//     .orderBy('created', 'desc')
//     .onSnapshot(snapshot =>{
//         setOrders(snapshot.docs.map(doc=>({
//             id:doc.id,
//             data: doc.data()
//         })))
//     })
//     .doc(paymentIntent.id)
//     .set({
//       cart:cart,
//       amount: paymentIntent.amount,
//       created: paymentIntent.created,
//     })
// }else {
//     setOrders([])
// }

// }, [user])


    return (
        <div className="orders">
            <h1>Your Orders</h1>
                <div className="orders_order">
                    {orders?.map(order=>(
                        <Order order={order}/>
                        ))}

                </div>

        </div>
    )
}

export default Orders
